<app-kontable
        [source]="employmentService.employments"
        [title]=" 'employmentList.sectionTitle' | translate"
        [columns]="['id', 'name']"
        [titles]="['common.id', 'employmentList.name']"
        [showInfoButton]="false"
        [showGlobalFilter]="false"
        [showRecoverButton]="false"
        [showDetailsButton]="false"
        [showAddButton]="true"
        (onAdd)="showAddOrEditDialog($event)"
        (onEdit)="showAddOrEditDialog($event)"
        (onRemove)="delete($event)"
>
</app-kontable>

<p-dialog
        *ngIf="addEditDialog"
        header="{{modalTitle}}"
        [(visible)]="addEditDialog"
        [modal]="true"
        [resizable]="false"
        [draggable]="false"
        [width]="500"
        (onHide)="closeAddDialog()">
  <kv-employment-form
    (employmentAdded)="employmentAdded($event)"
    (employmentUpdated)="employmentUpdated($event)"
    *ngIf="employmentService.employmentEditing"
    [dialogBoxEmployment]="employmentService.employmentEditing"
  ></kv-employment-form>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/employment/employment.component.html